<template>
	<div class="container" v-if="option">

		<header class="container__header">

			<div class="settings">

				<h1 v-text="option.title"></h1>

				 <ws-dropdown>

					<template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

					<template slot="content">

						<ul>
							<li><router-link :to="{name:'option.edit', params:{option:option.id}}"><i class="fas fa-pencil-alt"></i> Rediger</router-link></li>
							<li><a :class="{'disabled':!option.may_delete}" href="#" @click.prevent="doShowDeleteModal" :disabled="!option.may_delete"><i class="fas fa-trash-alt"></i> Slet</a></li>
							<li>
								<a href="#" @click.prevent="doShowActivationModal" :class="{'disabled':!option.may_delete}" :disabled="!option.may_delete">
									<template v-if="!option.active"><i class="fas fa-eye"></i> Aktiver</template>
									<template v-else><i class="fas fa-eye-slash"></i> Deaktiver</template>
								</a>
							</li>
						</ul>

					</template>

				</ws-dropdown>

			</div>

			<h3 v-if="option.active">Status: Aktiv</h3>
			<h3 v-else>Status: Inaktiv</h3>

		</header>

		<div class="container__body container__body--lg">

			<header class="col-12 margin-b-50 flex--space">

				<h1>Statistik</h1>

				<div class="datepicker">

					<a href="#" @click.prevent="showDatePickerModal = true"><i class="icon--md fas fa-calendar-alt"></i> {{dateRangeText}}</a>

				</div>

			</header>

			<main class="stats">

				<section class="item">

					<h1> <animate-number
							:from="old_total_revenue_count"
							:to="stats.total_revenue_count"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalCount">
						</animate-number><span>stk</span>
					</h1>

					<h2>Antal solgte</h2>

					<p>Det totale antal solgte retter som tilvalg / tilkøb </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1><animate-number
							:from="old_total_number_of_orders"
							:to="stats.total_number_of_orders"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalNumberOfOrders">
					</animate-number><span>stk</span>
					</h1>

					<h2>Totale ordre</h2>

					<p>Det totale antal ordre </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1> <animate-number
							:from="old_total_revenue_count_as_option"
							:to="stats.total_revenue_count_as_option"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalCountAsOption">
						</animate-number><span>stk</span>
					</h1>

					<h2>Antal solgte retter (Tilvalg)</h2>

					<p>Det total antal solgte retter som tilvalg </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1> <animate-number
							:from="old_total_revenue_count_as_extra"
							:to="stats.total_revenue_count_as_extra"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalCountAsExtra">
						</animate-number><span>stk</span>
					</h1>

					<h2>Antal solgte retter (Tilkøb)</h2>

					<p>Det totale antal solgte retter som tilkøb, </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1><animate-number
							:from="old_total_revenue"
							:to="stripeAmount(stats.total_revenue).amountForEditing"
							duration="2000"
							easing="easeInOutCirc"
							mode="manual"
							ref="totalRevenue">
					</animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning</h2>

					<p>Den totale omsætning på retter som tilkøb </br> i den valgte tidsperiode.</p>

				</section>

			</main>

		</div>

		<ws-modal v-model="showDeleteModal">

			<div class="modal-wrap">

				<div class="modal--sm center">

					<span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon--lg margin-b-25"></i>

					<h1>Slet Ret</h1>

					<h2>Er du sikker på du vil slette {{option.title}}?</h2>

					<h3>Du kan ikke fortryde denne handling!</h3>

					<div class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteOption">Ja tak</a>

						<a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

					</div>

				</div>

			</div>

		</ws-modal>

		<ws-modal v-model="showDatePickerModal">

			<div class="modal-wrap">

				<div class="modal--sm center">

					<span class="close" @click.prevent="datePickerReset"><i class="fas fa-times"></i></span>

					<div class="datepicker-trigger"   id="datepicker-trigger">
						<AirbnbStyleDatepicker
								:trigger-element-id="'datepicker-trigger'"
								:inline="true"
								:mode="'range'"
								:date-one="dateStartForDatePicker"
								:date-two="dateEndForDatePicker"
								:showActionButtons="false"
								:monthsToShow="1"
								@date-one-selected="setStartDate"
								@date-two-selected="setEndDate"
						/>
					</div>

				</div>

			</div>

		</ws-modal>

		<ws-modal v-model="showActivationModal">

			<div class="modal-wrap">

				<div class="modal--sm center">

					<span class="close" @click.prevent="showActivationModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon--lg margin-b-25"></i>

					<h1 v-if="!option.active">Aktiver Produkt</h1>
					<h1 v-else>Deaktiver Produkt</h1>

					<h2 v-if="!option.active">Er du sikker på du vil aktivere {{option.title}}?</h2>
					<h2 v-else>Er du sikker på du vil deaktivere {{option.title}}?</h2>

					<div class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="optionActivation">Ja tak</a>

						<a href="#" @click.prevent="showActivationModal = false">Nej tak!</a>

					</div>

				</div>

			</div>

		</ws-modal>

	</div>
</template>

<script>
	import {format} from 'date-fns';
	import da from 'date-fns/locale/da';
    export default {
        name: "option-stats",
        data() {
            return {
                option:null,
				stats:null,
				showDeleteModal:false,
				showDatePickerModal:false,
				showActivationModal:false,
                dateStartForDatePicker:'',
                dateEndForDatePicker:'',
				dateStart:'',
				dateEnd:'',
				format,
                old_total_revenue:0,
                old_total_revenue_count:0,
                old_total_revenue_count_as_extra:0,
                old_total_revenue_count_as_option:0,
                old_total_number_of_orders:0,
			};
        },
		computed:{
          	dateRangeText(){
          	  	if(this.dateStart === '' && this.dateEnd === ''){
          	  	    return 'Vælg datoer'
				}
				let startDate = this.format(this.dateStart, 'MMMM DD, YYYY', {locale:da});
          	  	let endDate = this.format(this.dateEnd, 'MMMM DD, YYYY', {locale:da})
				return startDate.charAt(0).toUpperCase() + startDate.slice(1) + ' - ' + endDate.charAt(0).toUpperCase() + endDate.slice(1);
			},
		},
        methods: {
            getOption(){
                axios.get(`/api/admin/option/${this.$route.params.option}/stats`).then(response => {
                    this.option = response.data.data.option;
                    this.stats = response.data.data.stats;
                    setTimeout(()=>{
                        this.$refs.totalCount.start();
                        this.$refs.totalRevenue.start();
                        this.$refs.totalCountAsOption.start();
                        this.$refs.totalCountAsExtra.start();
                        this.$refs.totalNumberOfOrders.start();
					}, 500);
				});
			},
			getOptionStatsByRange(){
                axios.post(`/api/admin/option/${this.$route.params.option}/stats`,{
                    start: this.dateStart,
					end: this.dateEnd,
				}).then(response => {
                    this.old_total_revenue = this.stats.total_revenue;
                    this.old_total_revenue_count = this.stats.total_revenue_count;
                    this.old_total_revenue_count_as_extra = this.stats.total_revenue_count_as_extra;
                    this.old_total_revenue_count_as_option = this.stats.total_revenue_count_as_option;
                    this.old_total_number_of_orders = this.stats.total_number_of_orders;

                    this.option = response.data.data.option;
                    this.stats = response.data.data.stats;

                    setTimeout(()=>{
                        this.$refs.totalCount.reset(this.old_total_revenue_count, this.stats.total_revenue_count);
                        this.$refs.totalRevenue.reset(this.stripeAmount(this.old_total_revenue).amountForEditing, this.stripeAmount(this.stats.total_revenue).amountForEditing);
                        this.$refs.totalCountAsOption.reset(this.old_total_revenue_count_as_option, this.stats.total_revenue_count_as_option);
                        this.$refs.totalCountAsExtra.reset(this.old_total_revenue_count_as_extra, this.stats.total_revenue_count_as_extra);
                        this.$refs.totalNumberOfOrders.reset(this.old_total_number_of_orders, this.stats.total_number_of_orders);

                        this.$refs.totalCount.start();
                        this.$refs.totalRevenue.start();
                        this.$refs.totalCountAsOption.start();
                        this.$refs.totalCountAsExtra.start();
                        this.$refs.totalNumberOfOrders.start();
                    }, 500);
                });
			},
			revenueFormatter(num){
                num = this.stripeAmount(num).amountForEditing;
                return num > 999 ? (num/1000).toFixed(0) + 'k' : num.toFixed(0);
			},
			deleteOption(){
                if(!this.option.may_delete){
                    return;
				}

                axios.delete(`/api/admin/option/${this.$route.params.option}`).then(()=>{
                    this.$router.replace({
                        name:'option.index',
                    })
				});
			},
			setStartDate(val){
                this.dateStartForDatePicker = val;
			},
			setEndDate(val){
                this.dateStart = this.dateStartForDatePicker;
				this.dateEnd = val;
				this.getOptionStatsByRange();
				this.datePickerReset()
			},
			datePickerReset(){
                this.showDatePickerModal = false;
                this.dateStartForDatePicker = '';
                this.dateEndForDatePicker = '';
			},
            optionActivation(){
                if(!this.option.may_delete){
                    return;
                }

                if(!this.option.active){
                    axios.put(`/api/admin/option/${this.option.id}/activate`).then(response=>{
                        this.showActivationModal = false;
                        this.getOption();
                    });
                }else{
                    axios.put(`/api/admin/option/${this.option.id}/deactivate`).then(response=>{
                        this.showActivationModal = false;
                        this.getOption();
                    });
                }

            },
			doShowDeleteModal(){
                if(!this.option.may_delete){
                    return;
                }
                this.showDeleteModal = true;
			},
            doShowActivationModal(){
                if(!this.option.may_delete){
                    return;
                }
                this.showActivationModal = true;
            }
		},
		mounted(){
			this.getOption();
		}
    }
</script>

<style scoped>

</style>
